import React from "react";
import {Image} from 'react-bootstrap';
import Header from "../components/Header/Header";
import EnterpriseNews from "../components/News/EnterpriseNews";
import IndustryNews from "../components/News/IndustryNews";
import PressRelease from "../components/News/PressRelease";
import Footer from "../components/Footer/Footer";
import BackToTop from "../components/BackToTop/BackToTop";

import "./News.css";

class News extends React.Component {
  render() {
    return (
      <div className="news">
        {/* 页头 */}
        <Header pageName="news"/>

        {/* 页头图 */}
        <Image src="https://hzby-devops.oss-cn-shanghai.aliyuncs.com/hzby_website/pho_banner_3.webp" className="news_bkimg" />

        {/* 企业动态 */}
        <EnterpriseNews />

        {/* 行业新闻 */}
        <IndustryNews />

        {/* 新闻公告 */}
        <PressRelease />

        {/* 页脚 */}
        <Footer />

        {/* 回到顶部 */}
        <BackToTop />
      </div>
    )
  }
}

export default News
